export const mergeArraysById = (
  array1: any[],
  array2: any[],
  idKey1: string,
  idKey2: string,
) => {
  const map = new Map();

  array1.forEach((item) => map.set(item[idKey1], item));

  array2.forEach((item) => {
    const id = item[idKey2];
    const existing = map.get(id);
    map.set(id, existing ? { ...existing, ...item } : item);
  });

  return Array.from(map.values());
};
